import { render, staticRenderFns } from "./UploadDesign.vue?vue&type=template&id=472dd521&scoped=true&"
import script from "./UploadDesign.vue?vue&type=script&lang=js&"
export * from "./UploadDesign.vue?vue&type=script&lang=js&"
import style0 from "./UploadDesign.vue?vue&type=style&index=0&id=472dd521&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472dd521",
  null
  
)

export default component.exports